import {
    FETCH_NOTIFICATIONS_REQUEST,
    FETCH_NOTIFICATIONS_SUCCESS,
    FETCH_NOTIFICATIONS_FAILURE,
    MARK_NOTIFICATION_READ_REQUEST,
    MARK_NOTIFICATION_READ_SUCCESS,
    MARK_NOTIFICATION_READ_FAILURE,
} from "./types";

import {
    fetchNotifications as fetchNotificationsApi,
    markNotificationAsRead as markNotificationAsReadApi,
} from "../../services/notificationService";

export const fetchNotificationsRequest =
    () => ({
        type: FETCH_NOTIFICATIONS_REQUEST,
    });

export const fetchNotificationsSuccess =
    (data) => ({
        type: FETCH_NOTIFICATIONS_SUCCESS,
        payload: data,
    });

export const fetchNotificationsFailure =
    (error) => ({
        type: FETCH_NOTIFICATIONS_FAILURE,
        payload: error,
    });

export const markNotificationReadRequest =
    () => ({
        type: MARK_NOTIFICATION_READ_REQUEST,
    });

export const markNotificationReadSuccess =
    (
        notificationId
    ) => ({
        type: MARK_NOTIFICATION_READ_SUCCESS,
        payload:
            notificationId,
    });

export const markNotificationReadFailure =
    (error) => ({
        type: MARK_NOTIFICATION_READ_FAILURE,
        payload: error,
    });
export const getNotifications =
    (
        filterField,
        filterValue,
        page = 1,
        size = 10,
    ) =>
        async (dispatch) => {
            

            dispatch(
                fetchNotificationsRequest()
            );

            try {
                const response =
                    await fetchNotificationsApi(
                        filterField,
                        filterValue,
                        page,
                        size,
                    );

                if (
                    !response.error
                ) {
                    dispatch(
                        fetchNotificationsSuccess(
                            response
                        )
                    );

                    return {
                        success: true,
                        data: response,
                    };
                }

                dispatch(
                    fetchNotificationsFailure(
                        response.error
                    )
                );

                return {
                    success: false,
                    error:
                        response.error,
                };
            } catch (error) {
                dispatch(
                    fetchNotificationsFailure(
                        error.message
                    )
                );

                return {
                    success: false,
                    error:
                        error.message,
                };
            }
        };

export const markNotificationRead =
    (
        notificationId,
    ) =>
        async (dispatch) => {
            dispatch(
                markNotificationReadRequest()
            );

            try {
                const response =
                    await markNotificationAsReadApi(
                        notificationId,
                    );

                if (
                    !response.error
                ) {
                    dispatch(
                        markNotificationReadSuccess(
                            notificationId
                        )
                    );

                    return {
                        success: true,
                    };
                }

                dispatch(
                    markNotificationReadFailure(
                        response.error
                    )
                );

                return {
                    success: false,
                    error:
                        response.error,
                };
            } catch (error) {
                dispatch(
                    markNotificationReadFailure(
                        error.message
                    )
                );

                return {
                    success: false,
                    error:
                        error.message,
                };
            }
        };